import devToggles from "@irati/dev-toggles"
import {DEFAULT_REWARD_POINTS_NAME} from "@shared/wallet"

export function resolveRewardPointsName(rewardPointsName?: string | null): string {
  if (!devToggles.showRewardPointsNameCustomization()) {
    return DEFAULT_REWARD_POINTS_NAME
  }

  return rewardPointsName ?? DEFAULT_REWARD_POINTS_NAME
}
